// extracted by mini-css-extract-plugin
module.exports = {"container":"Hb","block":"Ib","subheading":"Jb","cta":"Kb","disabled":"Lb","noBotMargin":"Mb","light":"Nb"};